var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_15021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.9628H5.81L4.165 26.9303H0.5V21.9628ZM0.5 12.5166H8.9375L7.2925 17.4841H0.5V12.5166ZM0.5 3.07031H12.065L10.42 8.03906H0.5V3.07031ZM17.3 3.07031H30.5V8.03906H15.6538L17.3 3.07031ZM12.525 17.4841L14.1713 12.5166H30.5V17.4841H12.525ZM11.045 21.9628H30.5V26.9316H9.39875L11.045 21.9628Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_15021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerless);
export default __webpack_public_path__ + "static/media/serverless.40fb807ddb00e1c2c41dfbc8bd0983c8.svg";
export { ForwardRef as ReactComponent };